import { ArpMedia, ORDER } from '@arpeggi/shared'
import { useState } from 'react'
import { useAsyncEffect } from '../../../__legacy__/components/platform/explore/common/utils'
import { OrderBy } from '../../../__legacy__/components/platform/new-explore/hooks/useSounds'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import ArpRegistry from '../../arp-registry/ArpRegistry'

export const useArpDNA = (media: IArpMedia) => {
  const [data, setData] = useState<IArpMedia[]>([])
  const [order, setOrder] = useState<ORDER>('desc')
  const [orderBy, setOrderBy] = useState<OrderBy>('createdAt')
  const status = useAsyncEffect(async () => {
    const { subComponents } = media
    const firstLayer = subComponents.map((id) => ArpRegistry.cache.get(id.toString()))
    const secondLayer = firstLayer.map((media) => media.subComponents).flat()
    if (secondLayer.length === 0) return setData([...firstLayer])
    const resp = await ArpRegistry.search({
      ids: secondLayer,
      perPage: 1000,
      parts: ['favoriteCount', 'subComponents']
    })
    setData([...resp.media, ...firstLayer])
  }, [media])
  const ordered = data.sort((a, b) => {
    const valueA = a[orderBy]
    const valueB = b[orderBy]
    if (typeof valueA === 'string') {
      return valueA.localeCompare(valueB)
    }
    return valueA - valueB
  })
  const reversed = order === 'desc' ? ordered : ordered.reverse()

  const handleOrderChange = (newOrderBy: OrderBy) => {
    if (newOrderBy === orderBy) return setOrder(order === 'asc' ? 'desc' : 'asc')
    setOrderBy(newOrderBy)
    setOrder('desc')
  }
  return { data: reversed as any as ArpMedia[], status, handleOrderChange, order, orderBy }
}
